import request from './axiosFun';
import apiHttp from './apiHttp';
// 根据用户id，项目id 查询用户开通项目
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 获取livestockType
export function getUserInfoV2(query) {
  // query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  // query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // query.applicationId = JSON.parse(localStorage.getItem('JDBM')).id;
  return apiHttp({
    url: url + '/pasture/personOrg/getUserInfoV2', // /pasture/personOrg/getUserInfo(旧接口，见犊补母烤炉多角色更改接口)
    method: 'post',
    data: query
  });
}

// 见犊补母旧接口 - 20241011
export function getUserInfoCall(query) {
  return apiHttp({
    url: url + '/pasture/personOrg/getCalfUserInfo',
    method: 'post',
    data: query
  });
}

// 见犊补母 - 多角色开启接口 20241012
export function postAllocationRole(query) {
  return apiHttp({
    url: url + '/pasture/personOrg/allocationRole',
    method: 'post',
    data: query
  });
}

// 获取需要安装设备
export function Equipmentapplication(query) {
  query.deptId = '810010';
  query.livestockType = '3';
  query.applicationId = '12';
  // query.nonInstall='nonInstall'
  // @ApiModelProperty(value="已经安装")
  // private String installed;
  // @ApiModelProperty(value="未经安装")
  // private String nonInstall;
  // @ApiModelProperty(value="想安装的")
  // private String thinkInstall;
  // @ApiModelProperty(value="安装意向")
  // private String installingCamera;
  query.thinkInstall = 'thinkInstall';
  query.installingCamera = 'installingCamera';
  return request({
    url: url + 'livestock/calfPreregister/queryFarmUserDeviceInfo',
    method: 'post',
    data: query
  });
}

// 角色统计
export function roleintongji(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/queryPersonCount',
    method: 'post',
    data: query
  });
}
// 查询角色信息
export function roleinformation(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/queryRoles',
    method: 'post',
    data: query
  });
}
// 保存人员信息（新建人员）
export function newpersonnel(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/savePersonInfo',
    method: 'post',
    data: query
  });
}
// 人员列表
export function personnellist(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/queryPersonInfo',
    method: 'post',
    data: query
  });
}
// 修改人员
export function editpersonnel(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/updatePersonInfo',
    method: 'post',
    data: query
  });
}
// 删除人员
export function deletepersonnel(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleId;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/personOrg/deletePersonInfo',
    method: 'post',
    data: query
  });
}
// 导入电子耳标
export function importEarNumberByImmuneEarNumber(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleId;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/calfLivestockInfo/importEarNumberByImmuneEarNumber',
    method: 'post',
    data: query
  });
}
// 导入人员
export function importpersonnel(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleId;
  // query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/fileExcel/importMessager',
    method: 'post',
    data: query
  });
}
// 配种机构导入
export function jigouimportpersonnel(query) {
  // query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  // query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/calfOrganizationUser/importExcelForOrganizationUserInfo',
    method: 'post',
    data: query
  });
}
// 负责人员
export function personincharge(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  // console.log(JSON.stringify(query) )
  return request({
    url: url + '/pasture/personOrg/queryFarmsOfMessenger',
    method: 'post',
    data: query
  });
}

// 设备列表
export function selectOnlineDeviceList(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/calfLivestockInfo/selectOnlineDeviceList',
    method: 'post',
    data: query
  });
}
// 见犊补母设备列表
export function selectOnlineDeviceListxinear(query) {
  query.applicationId = JSON.parse(localStorage.getItem('JDBM')).personOrg.applicationId;
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/device/cameraDevice/getAreaDeviceList',
    method: 'post',
    data: query
  });
}

// PC畜只列表
export function selectPCScaleLivestockList(query, loading) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/livestock/calfLivestockInfo/selectAppScaleLivestockList',
    method: 'post',
    data: query
  });
}
// PC畜只统计
export function getHomeLivestockCount(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/calfLivestockInfo/getHomeLivestockCount',
    method: 'post',
    data: query
  });
}
// PC畜只详情
export function selectScaleLivestockInfo(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/calfLivestockInfo/selectScaleLivestockInfo',
    method: 'post',
    data: query
  });
}
// 畜只 母牛查犊牛
export function selectCalfLivestockList(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/calfLivestockInfo/selectCalfLivestockList',
    method: 'post',
    data: query
  });
}
// 畜只 犊牛查母牛
export function selectFemaleLivestockList(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/calfLivestockInfo/selectFemaleLivestockList',
    method: 'post',
    data: query
  });
}

// PC牧场申请管理
export function pcCalfApplyBeanPage(query, loading) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/livestock/subsidiesApply/pcCalfApplyBeanPage',
    method: 'post',
    data: query
  });
}
// PC牧场申请统计
export function pcCalfApplyBeanCount(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/subsidiesApply/pcCalfApplyBeanCount',
    method: 'post',
    data: query
  });
}
// PC防疫管理列表
export function pcepidemicprevention(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/subsidiesApply/pcCalfMaterOutStockPage',
    method: 'post',
    data: query
  });
}
// PC产业主体管理列表
export function Industrialsubject(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/calfPreregister/selectPCCalfPreregisterPage',
    method: 'post',
    data: query
  });
}
// PC产业主体管理统计
export function Industristatistics(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/calfpreregister/selectPCCalfPreregisterCount',
    method: 'post',
    data: query
  });
}
// 信息员-行政区域获取
export function administrative(query) {
  // query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  // query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return apiHttp({
    url: url + '/livestock/calfPreregister/getAreaInfoByDeptId',
    method: 'post',
    data: query
  });
}
// 验证图片
export function verification(query) {
  // query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  // query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/base-server/aliOperate/ocrInfo',
    method: 'post',
    data: query
  });
}
// 变更-信息员信息
export function Informationistinformation(query) {
  //  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  //   query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/personOrg/changeMessengerInfo',
    method: 'post',
    data: query
  });
}
// 人员信息变更
export function biangengmationistinformation(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/personOrg/changePersonInfo',
    method: 'post',
    data: query
  });
}
// 死亡上报
export function deathreport(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/livestock/calfLivestockOut/findPCLivestockOutList',
    method: 'post',
    data: query
  });
}
// PC防疫管理列表导出
export function pcepidemicpreventiondaochu(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/livestock/subsidiesApply/exportCalfMaterOutStock',
    method: 'post',
    data: query
  });
}
// PC配种机构管理查询
export function queryCalfOrganizationUserPage(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  query.roleCode = JSON.parse(localStorage.getItem('JDBM')).roleCode;
  query.areaCode = JSON.parse(localStorage.getItem('JDBM')).areaCodeString;
  return request({
    url: url + '/pasture/calfOrganizationUser/queryCalfOrganizationUserPage',
    method: 'post',
    data: query
  });
}
// PC配种机构管理编辑
export function updCalfOrganizationUser(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/calfOrganizationUser/updCalfOrganizationUser',
    method: 'post',
    data: query
  });
}
// PC配种机构管理新增
export function addCalfOrganizationUser(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/calfOrganizationUser/addCalfOrganizationUser',
    method: 'post',
    data: query
  });
}
// PC配种机构管理删除
export function delCalfOrganizationUser(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + '/pasture/calfOrganizationUser/delCalfOrganizationUser',
    method: 'post',
    data: query
  });
}

// PC 新增信息员/管理员（负责区域列表）
export function selectOrderByAreas(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return apiHttp({
    url: url + 'pasture/sys/selectOrderByAreas',
    method: 'post',
    data: query
  });
}
// PC 新增信息员/管理员（负责区域列表）
export function selectOrderByAreasearar(query) {
  return apiHttp({
    url: url + '/pasture/sys/selectOrderByAreas',
    method: 'post',
    data: query
  });
}
// PC 新增信息员/管理员（负责区域列表）
export function selectOrderByAreasear(query) {
  query.deptId = '810010';
  query.livestockType = '3';
  return apiHttp({
    url: url + '/pasture/sys/selectOrderByAreas',
    method: 'post',
    data: query
  });
}
// PC 畜只类型
export function animaltype(query) {
  query.deptId = JSON.parse(localStorage.getItem('JDBM')).deptId;
  query.livestockType = JSON.parse(localStorage.getItem('JDBM')).livestockType;
  return request({
    url: url + 'pasture/dynamicData/getClassifyCattleType',
    method: 'post',
    data: query
  });
}

// PC管理员代办统计
export function getPcAdminWaitCount(query) {
  return apiHttp({
    url: url + '/livestock/calfLivestockOut/getPcAdminWaitCount',
    method: 'post',
    data: query
  });
}
// 人员在畜牧平台项目中的角色、机构、管理辖区信息获取
export function getZiZhouUserInfo(query) {
  return request({
    url: url + '/pasture/wisdomManage/getXmptUserInfo',
    method: 'post',
    data: query
  });
}
// 疫病检测地图数据
export function queryVaccination(query) {
  return apiHttp({
    url: url + '/project-server/technicalService/queryVaccination',
    method: 'post',
    data: query
  });
}

// 饲喂品种
export function getDataByDynamicCode(query) {
  return apiHttp({
    url: url + '/pasture/dynamicData/getDataByDynamicCode',
    method: 'post',
    data: query
  });
}

// PC 牧场新增修改-后台添加
export function saveFarmByAdmin(query) {
  return request({
    url: url + '/base-server/userAuth/saveFarmByAdmin',
    method: 'post',
    data: query
  });
}
// PC 牧场删除
export function deleteFarm(query) {
  return request({
    url: url + '/base-server/userAuth/deleteFarm',
    method: 'post',
    data: query
  });
}
// PC 牧场导入
export function importSubject(query) {
  return request({
    url: url + '/base-server/farm/importSubject',
    method: 'post',
    data: query
  });
}
// PC 天眼查
export function fuzzySearch(query) {
  return request({
    url: url + '/pasture/tianyancha/fuzzySearch',
    method: 'post',
    data: query
  });
}

// 见犊补母 - 大屏接口
export function jdbmScreenBaseData(query) {
  const JDBM = JSON.parse(localStorage.getItem('JDBM'));
  query.applicationId = JDBM.personOrg.applicationId;
  query.areaId = JDBM.personOrg.manageAreaCode;
  query.livestockType = JDBM.personOrg.livestockType;
  query.deptId = JDBM.personOrg.deptId;
  query.roleCode = JDBM.roleCode;
  return request({
    url: url + '/project-server/screen/screenBaseData',
    method: 'post',
    data: query
  });
}

export function getCalfAreaLivestockCount(query) {
  const JDBM = JSON.parse(localStorage.getItem('JDBM'));
  query.areaId = JDBM.personOrg.manageAreaCode;
  query.livestockType = JDBM.personOrg.livestockType;
  query.areaLevel = JSON.parse(localStorage.getItem('info')).provincialAndMunicipalLevel;
  return request({
    url: url + '/project-server/calfDataInfo/getCalfAreaLivestockCount',
    method: 'post',
    data: query
  });
}

// 见犊补母大数据平台-肉牛增量提质行动
export function queryCalfLivestockCount(query) {
  const JDBM = JSON.parse(localStorage.getItem('JDBM'));
  query.livestockType = JDBM.personOrg.livestockType;
  query.roleCode = JDBM.roleCode;
  query.deptId = JDBM.personOrg.deptId;
  query.areaCode = JDBM.areaCodeString;
  return request({
    url: url + '/livestock/subsidiesApply/queryCalfLivestockCount',
    method: 'post',
    data: query
  });
}

// 见犊补母大数据平台-肉牛增量提质行动 (能繁母牛数量)
export function queryPlatformLivestockCount(query) {
  const JDBM = JSON.parse(localStorage.getItem('JDBM'));
  query.livestockType = JDBM.personOrg.livestockType;
  query.roleCode = JDBM.roleCode;
  query.deptId = JDBM.personOrg.deptId;
  query.areaCode = JDBM.areaCodeString;
  return request({
    url: url + '/livestock/subsidiesApply/queryPlatformLivestockCount',
    method: 'post',
    data: query
  });
}

/* 获取智慧畜牧地图数据 */
export function getZhxmUserInfo(query) {
  return request({
    url: url + '/pasture/wisdomManage/getZhxmUserInfo',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/cattlesubsidy.js